/*
 * @Author: mina.min
 * @Date: 2025-06-09 16:20:39
 * @LastEditors: mina.min
 * @LastEditTime: 2025-08-12 12:40:37
 * @FilePath: /OTA-frontend/src/App.tsx
 * @Description:
 */
import Layout from '@/components/Layout'
import CampaignManagement from '@/pages/CampaignManagement'
import ForcedUpgrade from '@/pages/CampaignManagement/ForcedUpgrade'
import Dashboard from '@/pages/Dashboard'
import DeviceManagement from '@/pages/DeviceManagement'
import FirmwareManagement from '@/pages/FirmwareManagement'
import Login from '@/pages/Login'
import LogManagement from '@/pages/LogManagement'
import ModuleList from '@/pages/ModuleManagement/ModuleList'
import ProjectPhase from '@/pages/ModuleManagement/ProjectPhase'
import { useAuthStore } from '@/stores/authStore'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import './App.css'

const App: React.FC = observer(() => {
  const authStore = useAuthStore()

  if (!authStore.isAuthenticated) {
    return <Login />
  }

  return (
    <Layout>
      <Routes>
        <Route path='/' element={<Navigate to='/firmware/list' replace />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/modules' element={<Navigate to='/modules/list' replace />} />
        <Route path='/modules/list' element={<ModuleList />} />
        <Route path='/modules/phase' element={<ProjectPhase />} />
        <Route path='/firmware' element={<Navigate to='/firmware/list' replace />} />
        <Route path='/firmware/*' element={<FirmwareManagement />} />
        <Route path='/campaigns' element={<Navigate to='/campaigns/list' replace />} />
        <Route path='/campaigns/list' element={<CampaignManagement />} />
        <Route path='/campaigns/force-upgrade' element={<ForcedUpgrade />} />
        <Route path='/devices' element={<Navigate to='/devices/list' replace />} />
        <Route path='/devices/list' element={<DeviceManagement />} />
        <Route path='/logs' element={<Navigate to='/logs/list' replace />} />
        <Route path='/logs/list' element={<LogManagement />} />
        <Route path='*' element={<Navigate to='/firmware/list' replace />} />
      </Routes>
    </Layout>
  )
})

export default App
